var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f1f5f6"}},[_c('admin-header'),_vm._t("default"),_c('admin-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }